import React, { useEffect, useRef, useState } from 'react';

const ImpactMetric = ({ value, label, icon: Icon, suffix = '', active }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!active) return undefined;
    const startedAt = performance.now();
    let frame;
    const animate = (time) => {
      const progress = Math.min((time - startedAt) / 1400, 1);
      setCurrent(Math.round(value * (1 - Math.pow(1 - progress, 3))));
      if (progress < 1) frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [active, value]);

  return (
    <article className="impact-card impact-card-premium">
      <span className="impact-card-icon impact-card-icon-premium" aria-hidden="true"><Icon /></span>
      <strong className="impact-number impact-number-premium">
        {new Intl.NumberFormat('en-US').format(current)}{suffix}
      </strong>
      <span className="impact-card-title impact-card-title-premium">{label}</span>
    </article>
  );
};

const LabImpact = ({ labName, metrics }) => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setActive(true);
        observer.disconnect();
      }
    }, { threshold: 0.2 });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  const headingId = `${labName.toLowerCase()}-impact-title`;
  return (
    <section ref={sectionRef} className="impact-section impact-section-premium" aria-labelledby={headingId}>
      <div className="impact-overlay impact-overlay-premium">
        <div className="impact-inner impact-inner-premium">
          <header className="impact-heading impact-heading-premium">
            <span className="impact-eyebrow">{labName} by the numbers</span>
            <h2 id={headingId}>Impact</h2>
          </header>
          <div className="impact-grid impact-grid-premium">
            {metrics.map((metric) => <ImpactMetric key={metric.label} {...metric} active={active} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LabImpact;
